import { useQuery } from '@apollo/react-hooks';
import { GetAttireCategories } from '../queries/guest-graphql-federation.graphql';
import { AttireCategory } from '../generated/graphql';

export interface AttireCategoryOption {
  value: string;
  label: string;
  description: string;
}

export const useAttireCategories = () => {
  const { data, loading, error } = useQuery(GetAttireCategories);

  const attireCategories: AttireCategoryOption[] =
    data?.attireCategories
      ?.filter((category: AttireCategory) => category?.id && category?.label)
      .map((category: AttireCategory) => ({
        value: category.id!,
        label: category.label!,
        description: category.description || '',
      })) || [];

  return {
    attireCategories,
    loading,
    error,
  };
};
